/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Edit_Rejected_HintInputs */



/**
* | output |
* | --- |
* | "The assistant tried to edit the document but the change could not be accepted. Ask it to read the document again and retry." |
*
* @param {Artifact_Edit_Rejected_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_edit_rejected_hint = /** @type {((inputs?: Artifact_Edit_Rejected_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Edit_Rejected_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die KI hat versucht, das Dokument zu bearbeiten, die Änderung konnte aber nicht übernommen werden. Bitte sie, das Dokument erneut zu lesen und es nochmal zu versuchen.")
	return /** @type {LocalizedString} */ ("The assistant tried to edit the document but the change could not be accepted. Ask it to read the document again and retry.")
});